export default __webpack_public_path__ + "static/media/Calendar.cd0dc2f5.svg";